
export function loginPayload(){
    return ({
        'email':'', 'password':''
    })
}


